const CommonConditions = {
  isAgent: (_) => {
    // check url is /agent-preview

    if (window.location.pathname === "/agent-preview") {
      return true;
    }

    if (window.location.search.includes("agent=")) {
      return true;
    }

    return false;
  },

  isSupervisor: (_) => {
    if (window.location.search.includes("supervisor=")) {
      return true;
    }

    return false;
  },
};

export default CommonConditions;
